import { render, staticRenderFns } from "./EventsBannerEdit.vue?vue&type=template&id=eb4b86d2&scoped=true"
import script from "./EventsBannerEdit.vue?vue&type=script&lang=js"
export * from "./EventsBannerEdit.vue?vue&type=script&lang=js"
import style0 from "./EventsBannerEdit.vue?vue&type=style&index=0&id=eb4b86d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4b86d2",
  null
  
)

export default component.exports